import { core_backend_url } from "../../config"

export const onboardApi = {
    'login' : `${core_backend_url}auth/login`,
    'register' : `${core_backend_url}auth/register`,
    'forgot_password': `${core_backend_url}auth/password-forgot`,
    'verify_email': `${core_backend_url}auth/verify/email`,
    'password_reset': `${core_backend_url}auth/password-reset`,
    'profile_creation':`${core_backend_url}auth/update-profile`,
    'resend_verification_link': `${core_backend_url}auth/resend-verification-link`,
    'resend_password_link': `${core_backend_url}auth/resend-password-reset-link`,
    'banks' : `${core_backend_url}auth/banks`,
}